import { render, staticRenderFns } from "./Seo4.vue?vue&type=template&id=ae0afd9c&scoped=true&"
import script from "./Seo4.vue?vue&type=script&lang=js&"
export * from "./Seo4.vue?vue&type=script&lang=js&"
import style0 from "./Seo4.vue?vue&type=style&index=0&id=ae0afd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0afd9c",
  null
  
)

export default component.exports